module.exports = __webpack_public_path__ + "static/media/cq_utente b.5bc4bb69.svg";